export default {
  default: 'default',
  danger: 'danger',
};
